// 📁 src/ContactPage.js

import React from 'react';

export default function ContactPage() {
  return (
    <div className="min-h-screen px-6 py-12 text-center text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
      <p className="text-lg">
        We’d love to hear from you. Please reach out at <strong>info@talentraxion.com</strong>
      </p>
    </div>
  );
}
